import {useTranslation} from "./useTranslation";

export const useGetIpReplacementOptions = () => {
  const { cabinet: { orders: { ipReplacement: {
      reasons: { notWork, incorrectLocation, changeNetwork, lowSpeed, system, custom }
    } } } } = useTranslation();
  
  const reasons = {
    doesntWork:  "IT_DOESNT_WORK",
    incorrectLocation:  "INCORRECT_LOCATION",
    changeNetwork:  "CHANGE_THE_NETWORK",
    lowSpeed:  "LOW_SPEED",
    system: "SYSTEM_PROCESSING",
    custom:  "CUSTOM",
  };
  
  const options = [
    { value: reasons.doesntWork, label: notWork },
    { value: reasons.incorrectLocation, label: incorrectLocation },
    { value: reasons.changeNetwork, label: changeNetwork },
    { value: reasons.lowSpeed, label: lowSpeed },
    { value: reasons.system, label: system },
    { value: reasons.custom, label: custom }
  ];
  
  return [reasons, options];
};
